import { leadApi } from "../../api";

export async function createCase(answers, documents = {}) {
  const processedDocuments = await Promise.all(
    documents.map(async (document) => ({
      fileName: document.name,
      fileData: await getFileBase64Content(document),
    }))
  );

  const { data } = await leadApi.createCase({
    ...answers,
    documents: processedDocuments,
  });

  return data.createdCase.id;
}

export async function updateCaseById(leadId, answers) {
  return leadApi.updateCaseById(leadId, answers);
}

function getFileBase64Content(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.addEventListener(
      "load",
      function () {
        const dataUrl = reader.result;
        const [, base64Content] = dataUrl.split(",");

        resolve(base64Content);
      },
      false
    );

    reader.addEventListener(
      "error",
      function () {
        reject(reader.error);
      },
      false
    );

    reader.readAsDataURL(file);
  });
}
